import { gql } from '@apollo/client'

export const LOGIN = gql`

#  $(dollar sign) represent variable in mutation function
query login ($email: String, $password: String){
  login(LoginInput: { email: $email, password: $password  }) {
    _id
    name
    userName
    email
    token
  }
}
`